export type SchemaEditorMode = "interactive" | "json";

export type SchemaParameterType =
  | "string"
  | "number"
  | "integer"
  | "boolean"
  | "object"
  | "array"
  | "variable";

export const SCHEMA_PARAMETER_TYPES: SchemaParameterType[] = [
  "string",
  "number",
  "integer",
  "boolean",
  "object",
  "array",
  "variable",
];

export const isSchemaParameterType = (type: string): type is SchemaParameterType =>
  SCHEMA_PARAMETER_TYPES.includes(type as SchemaParameterType);

export type CompositionKeyword = "oneOf" | "anyOf" | "allOf";

/** One branch of a property-level ``oneOf`` / ``anyOf`` / ``allOf``. */
export interface CompositionBranch {
  $ref?: string;
  /** Non-``$ref`` branch kept verbatim for round-trip (edit in JSON panel). */
  inlineSchema?: Record<string, unknown>;
}

// Schema for array items (simple arrays like "array of strings")
export interface ArrayItemsSchema {
  type: string;
  description: string;
  enum?: string[];
  additionalProperties?: boolean;
}
